"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var api_1 = require("../../utils/api");
var Rails_1 = require("../../utils/Rails");
var utils_1 = require("../../utils/utils");
var graph_ql_1 = require("../../types/graph-ql");
var constants_1 = require("./constants");
var config_1 = __importStar(require("../../config"));
var getHomePage_1 = __importDefault(require("./queries/getHomePage"));
var selectors_1 = require("./selectors");
var selectors_2 = require("../devices/selectors");
/**
 *
 * @param sectionId selected nav menu item id
 * @param initialRailSize initial loading size for each rail, load all if undefined
 * @param reloadRailId reload all the existing tile for the specific rail.
 * @param ignoreContinueWatching should query ignore pagination for continue watching rail or not
 */
exports.fetchContent = function (_a) {
    var initialRailSize = _a.initialRailSize, reloadRailId = _a.reloadRailId, _b = _a.isDynamicHero, isDynamicHero = _b === void 0 ? false : _b, ignoreContinueWatching = _a.ignoreContinueWatching, needReverseEPG = _a.needReverseEPG, sectionId = _a.sectionId, appId = _a.appId;
    return function (dispatch, getState) {
        var _a, _b, _c;
        // Check if the device is a TV device base on appId
        var isTVDevice = appId ? [graph_ql_1.AppId.SkyBox, graph_ql_1.AppId.SkyPod].includes(appId) : false;
        var deviceId = selectors_2.getSerialNumber(getState());
        var reloadRail;
        if (reloadRailId) {
            var railInfo = selectors_1.rail(getState())(reloadRailId);
            reloadRail = {
                id: reloadRailId,
                size: Array.isArray((_a = railInfo === null || railInfo === void 0 ? void 0 : railInfo.contentPage) === null || _a === void 0 ? void 0 : _a.content)
                    ? (_c = (_b = railInfo === null || railInfo === void 0 ? void 0 : railInfo.contentPage) === null || _b === void 0 ? void 0 : _b.content) === null || _c === void 0 ? void 0 : _c.length : undefined,
            };
        }
        return dispatch(api_1.createApiAction(constants_1.FETCH_CONTENT, {
            baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
            params: {
                query: getHomePage_1.default(initialRailSize, reloadRail, ignoreContinueWatching, isDynamicHero, needReverseEPG),
                variables: reloadRail
                    ? {
                        railId: reloadRailId,
                        id: utils_1.isNotNilOrEmpty(sectionId) ? sectionId : 'home',
                        appId: appId,
                        deviceId: utils_1.isNotNilOrEmpty(deviceId) ? deviceId : null,
                        isTVDevice: isTVDevice,
                    }
                    : {
                        id: utils_1.isNotNilOrEmpty(sectionId) ? sectionId : 'home',
                        appId: appId,
                        deviceId: utils_1.isNotNilOrEmpty(deviceId) ? deviceId : null,
                        isTVDevice: isTVDevice,
                    },
            },
            meta: { sectionId: sectionId },
            authenticated: true,
            graphQL: true,
        }));
    };
};
exports.fetchRailById = function (railId, sectionId, appId, nextPageSize) { return function (dispatch, getState) {
    var _a;
    var deviceId = selectors_2.getSerialNumber(getState());
    var railInfo = selectors_1.rail(getState())(railId);
    var endCursor = (_a = railInfo === null || railInfo === void 0 ? void 0 : railInfo.contentPage.pageInfo) === null || _a === void 0 ? void 0 : _a.endCursor;
    return dispatch(Rails_1.createFetchRailAction(constants_1.FETCH_RAIL, railId, endCursor, sectionId, appId, deviceId, nextPageSize));
}; };
//# sourceMappingURL=actions.js.map